import {createSlice} from '@reduxjs/toolkit';
import {IOneOrder} from '../../types'
import reducers from './reducers'
import extraReducers from './extraReducers'

export * from '../../thunk/mockupsCustomers';

const MockupsCustomersSlice = createSlice({
    name: "mockupsCustomers",
    initialState: {
        data: [],
        stats:{},
        status: null,
        error: null,
        queryParams: null,
    },
    reducers:{
        updateCustomerStatus: (state, action) => {
            const customers = state.data;
            // @ts-ignore
            const updatedCustomers = customers.map(customer =>
                // @ts-ignore
                customer.customerId === action.payload.customerId ? { ...customer, isBlocked: action.payload.isBlocked } // змінюємо лише isBlocked
                    : customer                     // решту залишаємо без змін
            );
            // @ts-ignore
            state.data = [...updatedCustomers]
        },
    },
    extraReducers
});
const {actions, reducer} = MockupsCustomersSlice;
export const {updateCustomerStatus} = actions;
export {reducer};
